import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function StickyTopBar() {
  // 30 minutes countdown
  const {
    days,
    hours,
    minutes,
    seconds
  } = useCountdown(0, 30, 0);
  return <div className="sticky top-0 z-50 w-full animate-pulse-bar bg-crimson py-2 px-4 shadow-md" data-id="element-187">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-188">
        <p className="font-montserrat font-bold text-white text-xs sm:text-sm tracking-wide" data-id="element-189">
          ⚡ Oferta válida por tiempo limitado
        </p>
        <div className="flex items-center bg-black/20 rounded px-2 py-1" data-id="element-190">
          <span className="font-montserrat font-bold text-white text-xs sm:text-sm tabular-nums tracking-wider" data-id="element-191">
            {days}:{hours}:{minutes}:{seconds}
          </span>
        </div>
      </div>
    </div>;
}